import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  adsById: null
};


export default function ads (state = initialState, action) {
  switch (action.type) {
    case types.SET_ADS:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_ADS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case types.SET_ADS_BY_ID:
      return {
        ...state,
        adsById: action.payload
      };
    default:
      return state;
  }
}